import { render, staticRenderFns } from "./CompanySignup.vue?vue&type=template&id=030d8484&lang=html"
import script from "./CompanySignup.vue?vue&type=script&lang=js"
export * from "./CompanySignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports